import FrontSonda from '@bit/gerenciatd.utils.front-sonda';

export const normalizeCreateCQResponse = (response, context) => {
  // Si vienen dos promociones en el primer nivel se envía error a IC y no se devuelve ninguna al frontal
  let warning = '';

  if (
    response &&
    Array.isArray(response.customerQuoteItems) &&
    response.customerQuoteItems[0] &&
    response.customerQuoteItems[0].productOffering &&
    Array.isArray(
      response.customerQuoteItems[0].productOffering.productPromotions,
    ) &&
    response.customerQuoteItems[0].productOffering.productPromotions.length > 1
  ) {
    // Vaciamos el array y completamos el nombre del error
    warning = 'Recibimos las promociones: ';
    response.customerQuoteItems[0].productOffering.productPromotions.forEach(
      (elem) => {
        warning += `${elem.id},`;
      },
    );
    warning += 'y no se sabe cuál aplicar, sólo debería haber una a lo máximo';
    const frontSonda = new FrontSonda({
      processName: 'normalizeCreateCQResponse',
      context,
      filePath: 'adabyron/cqv2/normalizers',
    });
    // TODO fix definition on this method on frontSonda, error may be nullable
    frontSonda.warningMessage({ info: warning, error: null });
    response.customerQuoteItems[0].productOffering.productPromotions = [];
  }

  return response;
};

export const normalizeGetProvisionalAgreementResponse = (
  datos: any,
): {
  agreementApplies: boolean;
  attachments: { content: any; name: string }[];
} => {
  const { precontrato, attachments: receivedAttachments } = datos;

  let agreementApplies = false;
  const attachments = [];

  if (precontrato === '1') {
    agreementApplies = true;
    if (Array.isArray(receivedAttachments)) {
      receivedAttachments.forEach((elem) => {
        attachments.push({
          content: elem.content,
          name: elem.name,
        });
      });
    }
  }

  const normalizedResponse = {
    agreementApplies,
    attachments,
  };

  return normalizedResponse;
};
